import React from "react";
import {
  FaCar,
  FaShieldAlt,
  FaHandHoldingUsd,
  FaExchangeAlt,
} from "react-icons/fa";
import styles from "../../styles/HomePage.module.css"; // ✅ Required import

const services = [
  {
    icon: <FaCar />,
    title: "Free Inspection",
    desc: "Get your car inspected for free by our experts and get the best price for your used car.",
  },
  {
    icon: <FaShieldAlt />,
    title: "1 Year Warranty",
    desc: "All our certified cars come with 1 year warranty for complete peace of mind.",
  },
  {
    icon: <FaHandHoldingUsd />,
    title: "Easy Financing",
    desc: "Get approved for financing in minutes with our trusted banking partners.",
  },
  {
    icon: <FaExchangeAlt />,
    title: "Quick Sale",
    desc: "Sell your car in just 1 hour with our instant cash payment option.",
  },
];

const Services = () => {
  return (
    <section className={styles.services}>
      <div className={styles.container}>
        <div className={styles.sectionTitle}>
          <h2>Our Services</h2>
        </div>
        <div className={styles.serviceGrid}>
          {services.map((service, idx) => (
            <div key={idx} className={styles.serviceCard}>
              <div className={styles.serviceIcon}>{service.icon}</div>
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
